
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
} from '@mui/material';
import {
  AssignmentTurnedIn as TaskIcon,
  CloudUpload as UploadIcon,
  Add as AddIcon,
  Description as DocumentIcon,
  Payment as InvoiceIcon,
  AccountBalance as TaxIcon
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Calayout';

// Wrap MUI Card with motion
const MotionCard = motion(Card);

const QuickActionCard = ({ icon, title, description, linkTo }) => (
  <MotionCard
    sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    whileHover={{ scale: 1.03 }}
    whileTap={{ scale: 0.98 }}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
  >
    <CardContent sx={{ flexGrow: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
        {icon}
        <Typography variant="h6" sx={{ marginLeft: 2 }}>
          {title}
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </CardContent>
    <CardActions>
      <Button 
      sx={{color:"black",backgroundColor:"#EB5A3C"}}
        component={Link}
        to={linkTo}
        variant="contained" 
        
        fullWidth 
        startIcon={<AddIcon />}
      >
        Take Action
      </Button>
    </CardActions>
  </MotionCard>
);

const CaQuickActions = () => {
  const quickActions = [
    {
      icon: <UploadIcon color="primary" />,
      title: "Upload Document",
      description: "Quickly upload client documents, tax returns, or financial statements",
      linkTo: "/upload"
    },
    {
      icon: <AddIcon color="success" />,
      title: "Add New Client",
      description: "Create a new client profile with essential information",
      linkTo: "/kycForm"
    },
    {
      icon: <TaskIcon color="secondary" />,
      title: "Create Task",
      description: "Assign a new task or project to your team",
      linkTo: "/CaTasks"
    },
    {
      icon: <InvoiceIcon color="warning" />,
      title: "Generate Invoice",
      description: "Create and send invoices to clients quickly",
      linkTo: "/invoicemanagement"
    },
    {
      icon: <TaxIcon color="error" />,
      title: "Tax Preparation",
      description: "Start a new tax preparation process for a client",
      linkTo: "/CaTaxPrepatation"
    },
    {
      icon: <DocumentIcon color="info" />,
      title: "Document Center",
      description: "Access, organize, and manage client documents",
      linkTo: "/CaDocumentCenter"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <Layout>
      <Box sx={{ flexGrow: 1, padding: 3, backgroundColor: '#F5F5F5' }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h4" sx={{ marginBottom: 3, color: '#333' }}>
            Quick Actions
          </Typography>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <Grid container spacing={3}>
            {quickActions.map((action, index) => (
              <Grid item xs={12} md={4} key={index}>
                <QuickActionCard {...action} />
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Box>
    </Layout>
  );
};

export default CaQuickActions;